import { memo } from 'react';
import { SOCIAL_PLATFORMS } from './icons';

/**
 * Footer — social icon strip on the tertiary wash, the compliance disclaimer,
 * then the gradient legal bar with the copyright and ClientWave360 links.
 */
export const Footer = memo(({ name, socialLinks = {}, disclaimer }) => {
  const socials = SOCIAL_PLATFORMS.filter(({ key }) => socialLinks[key]);
  const copyright = `© ${new Date().getFullYear()}${name ? ` ${name}.` : ''} All rights reserved.`;

  return (
    <footer className="site-footer">
      {socials.length > 0 && (
        <div className="footer-social-band">
          <ul className="footer-social">
            {socials.map(({ key, label, Icon }) => (
              <li key={key}>
                <a href={socialLinks[key]} target="_blank" rel="noopener noreferrer" aria-label={label}>
                  <Icon />
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}

      {disclaimer && (
        <div className="footer-disclaimer-band" id="disclaimer">
          <p className="cw-container footer-disclaimer">{disclaimer}</p>
        </div>
      )}

      <div className="footer-legal-band">
        <div className="cw-container footer-legal">
          <p className="footer-copyright">{copyright}</p>
          <ul className="footer-links">
            <li>
              <a href="https://clientwave360.com/privacy-policy" target="_blank" rel="noopener noreferrer">
                Privacy Policy
              </a>
            </li>
            <li>
              <a href="https://clientwave360.com/terms-of-use" target="_blank" rel="noopener noreferrer">
                Terms of Service
              </a>
            </li>
            <li>
              <span className="footer-powered">
                Powered by{' '}
                <a href="https://clientwave360.com" target="_blank" rel="noopener noreferrer">
                  ClientWave 360
                </a>
              </span>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
});
